<template>
	<div>
		<div style="text-align: left;">
			<el-button size="small" type="primary" icon="el-icon-plus" @click="addPow">新增</el-button>
		</div>
		<div class="comStyle">
			 <el-table :header-cell-style="{background:'#eee',color:'#606266'}"
			    :data="tableData"
				@selection-change="handleSelectionChange"
				:row-class-name="tableRowClassName"
				size="mini"
			    style="width: 100%">
				<el-table-column
				        type="selection"
				        width="55">
				</el-table-column>
			    <el-table-column type="expand">
			      <template slot-scope="props">
			        <el-form label-position="left" inline class="demo-table-expand-pow" size="mini">
						<el-row><el-form-item label="数据页面" class="el-form-it-pow"><br>
			          
			            <span v-for="(item,key) in props.row.tabs" :key="key" >	
							<el-row>
							<el-form-item label="ID">{{key+1}}</el-form-item>
							
							<el-form-item  label="名称" >{{item.name}}</el-form-item>
							</el-row>
							<!-- ID:{{}}——名称：{{ item.name}}</el-form-item> -->
						</span>
					  	
			          </el-form-item>
			          <el-form-item label="配置菜单"><br>
			            <span v-for="(item,key) in props.row.menu" :key="key">
							<el-row>
							<el-form-item label="ID">{{key+1}}</el-form-item>
							<el-form-item label="名称">{{item.name}}</el-form-item>
							</el-row>
						</span>
			          </el-form-item></el-row>
			          
			        </el-form>
			      </template>
			    </el-table-column>
			    <el-table-column
			      label="ID"
			      prop="id">
			    </el-table-column>
			    <el-table-column
			      label="名称"
			      prop="name">
			    </el-table-column>
			    <el-table-column
			      label="描述"
			      prop="description">
			    </el-table-column>
			  </el-table>
			</div>
			<div style="text-align: left;">
				<el-button size="small" type="danger" icon="el-icon-check" @click="updatePow"
				:disabled="multipleSelection.length==0">编辑</el-button>
				<el-button size="small" type="danger" icon="el-icon-minus" @click="deletePow"
				:disabled="multipleSelection.length==0">删除</el-button>
			</div>
			<el-dialog
				  :title="namelg"
				  :visible.sync="dialogVisible"
				  
				  width="30%">
			 <el-form :rules="rules"
				  ref='updatePos' label-position="right" label-width="110px"
				  :model="updatePos" class="comDia" size="mini">
				  <span>
				  <el-form-item label="ID" >
				  <el-input class="updatePosInput-pow" size="small" v-model="updatePos.id" 
				  :disabled="true" ></el-input>
				  </el-form-item>

				  <el-form-item label="名称" prop="name">
				  <el-input autofocus="off" class="updatePosInput-pow" size="small" v-model="updatePos.name"></el-input>
				  </el-form-item>
				  </span>
				  <el-form-item label="描述" prop="description">
				  <el-input autofocus="off" class="updatePosInput-pow" size="small" v-model="updatePos.description"></el-input>
				  </el-form-item>

				  <el-form-item label="数据页面" prop="tabsId">
					  <el-select multiple   
					  v-model="updatePos.tabsId" placeholder="请选择数据页面" >
						   <el-option v-for="(item,index) in tabSelect" :label="item.name" :key="index" :value="item.id"></el-option>						   
					  </el-select>
				   <!-- <el-input autofocus="off" class="updatePosInput-pow" size="small" v-model="updatePos.parity"></el-input> -->
				  </el-form-item>
				  <el-form-item label="系统配置" prop="menuId">
					  <el-select multiple   
					  v-model="updatePos.menuId" placeholder="请选择系统配置" >
						   <el-option v-for="(item,index) in menuSelect" :label="item.name" :key="index" :value="item.id"></el-option>						   
					  </el-select>
				   <!-- <el-input autofocus="off" class="updatePosInput-pow" size="small" v-model="updatePos.parity"></el-input> -->
				  </el-form-item>	
				  <el-form-item>
				  <el-button size="small" @click="dialogVisible = false">取 消</el-button>
				  <el-button size="small" type="primary" @click="doUpdate(updatePos)">确 定</el-button>
				  </el-form-item>
			  </el-form>
			  
		  </el-dialog>
	</div>
</template>

<script>
	export default {
		name: "SysPow",	
		data() {
		let missionPass = (rule, value, callback) => { //就是我们的回调函数，需要大家注意的是，这个没有在return的对象中，在data中
			  console.log(value)
			  debugger
			  if (value.indexOf(this.ruleMId[0])!=-1&&value.indexOf(this.ruleMId[1])!=-1) {
				
				  callback()
				
			  } else {
				  callback(new Error('缺必选项'+this.ruleMName[0]+'和'+this.ruleMName[1]))
				}
			};
		
		  return {
			namelg:"更新权限配置",
		    tableData: [],
			dialogVisible: false,
			showf:true,
			multipleSelection: [],
			tabSelect:[],
			menuSelect:[],
			ruleMId:[],
			ruleMName:[],
			updatePos: {
				id:'',
			    name:'',
			    version:1,
				description: '',
				tabsId: [],
				menuId: [],
				
			},
			rules:{
				name: [
					{ required: true,message: '名称不能为空！', trigger: 'blur' }
				],
				description:  [
					{ required: true, message: '描述不能为空！',trigger: 'blur' }
				],
				tabsId:  [
					{ required: true, message: '数据页面不能为空！',trigger: 'blur' }
				],
				menuId:  [
					{ required: true, message: '系统配置不能为空！',trigger: 'blur' },
					{ validator: missionPass, trigger: 'blur' } 
					// validator:对整个表单进行校验的方法，参数为一个回调函数。该回调函数会在校验结束后被调用，并传入两个参数：是否校验成功和未通过校验的字段。若不传入回调函数，则会返回一个 promise

				],
				
			}
		  };
		},
		mounted() {
			this.initLoad();
		},
		methods: {
			tableRowClassName({row, rowIndex}) {
				
				if ((rowIndex%2) == 1) {
				  return 'success-row';
				} 
				return '';
			  },
			addPow(){
				this.namelg='保存权限配置'
				this.updatePos.id='';
				this.updatePos.name='';
				this.updatePos.description='';
				this.updatePos.tabsId=[];
				this.updatePos.menuId=[];
				this.dialogVisible=true;
			},
			doUpdate(){
				this.$refs.updatePos.validate((valid) => {
					if (valid) {
						if(this.updatePos.id==''){
							this.$confirm('此操作新建一条记录', '提示', {
							        confirmButtonText: '确定',
							        cancelButtonText: '取消',
							        type: 'warning',
							}).then(() => {
							    debugger
								this.updatePos.id=null;
							    this.postRequest("/system/config/syspow",this.updatePos).then(resp => {
							        if (resp) {
							            this.initLoad();
										this.dialogVisible=false;
							        }
							    })
							}).catch(() => {
							    this.$message({
							        type: 'info',
							        message: '已取消保存',
									
							    });
								//this.dialogVisible=false;
							});
						}else{
							this.$confirm('此操作修改ID=【' + this.updatePos.id + '】的记录?', '提示', {
							        confirmButtonText: '确定',
							        cancelButtonText: '取消',
							        type: 'warning',
							}).then(() => {
							    debugger
							    this.postRequest("/system/config/syspow",this.updatePos).then(resp => {
							        if (resp) {
							            this.initLoad();
										this.dialogVisible=false;
							        }
							    })
							}).catch(() => {
								//this.dialogVisible=false;
							    this.$message({
							        type: 'info',
							        message: '已取消修改'
							    });
								
							});
						}
					} else {
						console.log('请输入所有字段！');
						return false;
					}
				})
				
				
			},
			updatePow(){
				if(this.multipleSelection.length!=1){
					this.$message({
					    type: 'warning',
					    message: '请选择单条数据编辑！'
					});
				}else{
					
					this.namelg='更新权限配置'
					this.multipleSelection.forEach(item => {
						this.updatePos.id=item.id;
						this.updatePos.name=item.name;
						this.updatePos.description=item.description;
						this.updatePos.tabsId=[];
						for(var i = 0; i < item.tabs.length; i++) {
							this.updatePos.tabsId.push(item.tabs[i].id)
						}
						this.updatePos.menuId=[];
						for(var i = 0; i < item.menu.length; i++) {
							
							this.updatePos.menuId.push(item.menu[i].id);
						}
						
						
						
					});
					this.dialogVisible=true;
					
					
				}
			},
			deletePow(){this.$confirm('此操作将永久删除【' + this.multipleSelection.length + '】条记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let ids = '?';
                    this.multipleSelection.forEach(item => {
                        ids += 'ids=' + item.id + '&';
                    })
                    this.deleteRequest("/system/config/syspow" + ids).then(resp => {
                        if (resp) {
                            this.initLoad();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
			initLoad(){
				this.getRequest("/system/config/syspow").then(resp => {
				    //this.loading = false;
				   
					this.$data.tableData = resp.role;
					this.$data.tabSelect=resp.tabs;
					this.$data.menuSelect=resp.menu;
					this.$data.ruleMId=[];
					this.$data.ruleMName=[];
					for(var j = 0,len=resp.menu.length; j < len; j++) {
					    if(resp.menu[j].name.indexOf("数据")!=-1
						||resp.menu[j].name.indexOf("修改密码")!=-1){
							this.$data.ruleMId.push(resp.menu[j].id);
							this.$data.ruleMName.push(resp.menu[j].name);
						}
					}
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
		  arraySpanMethod({ row, column, rowIndex, columnIndex }) {
		    if (rowIndex % 2 === 0) {
		      if (columnIndex === 0) {
		        return [1, 2];
		      } else if (columnIndex === 1) {
		        return [0, 0];
		      }
		    }
		  },
				
		  objectSpanMethod({ row, column, rowIndex, columnIndex }) {
		    if (columnIndex === 0) {
		      if (rowIndex % 2 === 0) {
		        return {
		          rowspan: 2,
		          colspan: 1
		        };
		      } else {
		        return {
		          rowspan: 0,
		          colspan: 0
		        };
		      }
		    }
		  }
		}
	}
</script>

<style>
	.comStyle{
		margin-bottom: 8px
	}
	.updatePosInput-pow {
	    width: 200px;
	    margin-left: 10px;
	}
	.comDia{
		/* text-align: left; 
		margin-left: 8px; */
		margin-bottom: 8px;
		padding: 15px 35px 15px 35px;
		
	}
	.el-table .success-row {
	    background: #f0f9eb;
	  }
	 .demo-table-expand-pow {
	    font-size: 0;
	  }
	  .demo-table-expand-pow label {
	    width: 70px;
	    color: #99a9bf;
	  }
	  .el-form-it-pow {
	    margin-right: 0;
	    margin-bottom: 0;
		margin-left: 0;
	    width: 50%;
	  } 
	  
</style>
